import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';


class NotScriptedList extends Component {
    constructor(props) {
        super(props);

        this.gerarListaNaoRoteirizados = this.gerarListaNaoRoteirizados.bind(this);
        this.handleError = this.handleError.bind(this);
        this.mostrarMascaraCep = this.mostrarMascaraCep.bind(this);
        this.Configurations = new Configurations();

        this.state = {
            naoRoterizados: [],
            isLoadingListaNaoRoteirizados: false,
            hasError: false,
            errorMessage: false
        }
    }

    componentWillMount() {
        this.gerarListaNaoRoteirizados();
    }

    gerarListaNaoRoteirizados() {
        this.setState({ isLoadingListaNaoRoteirizados: true })
        axios.get(this.Configurations.apiBasePath + `/logistica/naoRoterizados/lista-arquivos`).then(response => {
            this.setState({
                naoRoterizados: response.data.naoRoterizados,
                mensagem: response.data.message
            })
        }).catch(this.handleError).finally(() => { this.setState({ isLoadingListaNaoRoteirizados: false }) })
    }

    handleError(err) {
        this.setState({
            hasError: true,
            errorMessage: err.response ? err.response.data.message : 'Erro inesperado.'
        })
        console.log(err);
    }

    mostrarMascaraCep(cep) {
        cep = cep.replace(/\D/g, '');
        cep = cep.replace(/^(\d{5})(\d)/, "$1-$2");
        return cep;
    }

    render() {
        return (
            <div className='row no-gutters'>
                <div className='col-12'>
                    <div className="row pt-3 border-bottom border-dark no-gutters pb-2">
                        <div className='col-12'>
                            <h2 className='title-1'>Lista de não roteirizados da SPDL</h2>
                        </div>
                    </div>
                </div>
                {this.state.isLoadingListaNaoRoteirizados ? (
                    <div className='col-12 text-center py-3'>
                        <div className="spinner-border loading-spinner text-primary text-center" role="status" />
                    </div>
                ) : (
                    <React.Fragment>
                        <div className='col-12 text-center py-3'>
                            <h5><strong>{this.state.mensagem}</strong></h5>
                        </div>
                        <div className='col-12 text-center'>
                            <table className='lista-nao-roteirizados table w-100 text-center table-bordered '>
                                <thead>
                                    <tr>
                                        <th width="30%" className='text-center'>Remessa</th>
                                        <th width="30%" className='text-center'>CEP</th>
                                        <th width="30%" className='text-center'>Local de Entrega</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!this.state.naoRoterizados && this.state.naoRoterizados.length > 0 && (
                                        <React.Fragment>
                                            {this.state.naoRoterizados.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td width="30%" className='text-center'>{item.remessa}</td>
                                                        <td width="30%" className='text-center'>{this.mostrarMascaraCep(item.cep)}</td>
                                                        <td width="30%" className='text-center'>{item.localEntrega}</td>
                                                    </tr>
                                                )
                                            })}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>
                )}
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default NotScriptedList;